import type { FaireProductEntity } from "../../entity_types/product";

export const p_pj4t588xxu: FaireProductEntity = {
  token: "p_pj4t588xxu",
  type: "product",
  name: "Kids/Baby 2-Tone Cap: Mac & Cheese Enthusiast - Khaki/Beige",
  brandToken: "b_ee3ulfd69w",
  brandName: "Funky Junque",
  imageUrl:
    "https://cdn.faire.com/fastly/05afc1912f61ff7d8033c5276216150bf0dfd65367c21c44ee1fa85c14d02ad8.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d23d02e77274fe324d8464166e6b20af822d0dbf26a3e48dc859c1b62fc036f4.jpeg",
    "https://cdn.faire.com/fastly/547ea7311dca858ca7c51c880ca2f3397bf1ee4847ef2bbcf2e10a9eb3ffc707.jpeg",
    "https://cdn.faire.com/fastly/1611d840642bf7d7011b90650baf302db991323c3af7710068fbe2235d9d6480.jpeg",
    "https://cdn.faire.com/fastly/7c2d20fed9c0b65111e8cecc5b606df1d5ce343cb1ae30b94aa2311e83fe189e.jpeg",
    "https://cdn.faire.com/fastly/37a58b266e69b87fcd119a9bc0028d39e4addbc1944ee8fdb36e9156f5bca933.jpeg",
    "https://cdn.faire.com/fastly/5b976b4bb41fb6f00712b9cc3543d61ca1bcf2c4a6a9757d26ca22dc415af42a.jpeg",
  ],
  priceDollars: 11,
  description:
    "Made from 35% cotton and 65% polyester, this kids & infant baseball cap offers durability, comfort, and a stylish two-tone vintage design. Ideal for pairing with baby boy outfits or toddler essentials, it’s perfect for newborns and kids alike. Designed to protect delicate heads, it provides a snug, breathable fit and shields against the sun for year-round safety. The adjustable snapback ensures a customizable fit for growing children, available in three sizes: X-Small (0-12 months), Small (12-24 months), and Medium/Large (2-9 years). Whether as a baby baseball cap, toddler trucker hat, or youth snapback, this versatile accessory combines practicality, comfort, and style for all occasions.",
  tags: [],
  msrpDollars: 21,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:52:42.423Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
